
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";

/**
 * GroupCodeLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class GroupCodeLookupService<T = unknown> {
    private readonly $apiService = inject(ApiService);
    
    GetGroupCodeList(): Promise<T[]> {
        return this.$apiService.sendAuth("IGroupCodeLookupService/GetGroupCodeList");
    }
}
